import api from './api';

export const pricingService = {
  // Belirli bir işletme için fiyatlandırma bilgilerini getir
  getPricingInfo: async (businessId) => {
    try {
      // Business panel'den çağrılıyorsa business endpoint'ini kullan
      const response = await api.get(`/api/business/pricing/my-pricing`);
      return response.data;
    } catch (error) {
      console.error('Fiyatlandırma bilgisi getirilirken hata:', error);
      throw error;
    }
  },

  // Tüm işletmeler için fiyatlandırma özeti
  getAllPricingSummary: async () => {
    try {
      const response = await api.get('/api/admin/pricing/summary');
      return response.data;
    } catch (error) {
      console.error('Fiyatlandırma özeti getirilirken hata:', error);
      throw error;
    }
  },

  upgradeToPremium: async () => {
    try {
      const response = await api.post('/api/business/pricing/upgrade-to-premium');
      return response.data;
    } catch (error) {
      console.error('Premium plana yükseltme hatası:', error);
      throw error;
    }
  },

  // YENİ ÖDEME SİSTEMİ: Mevcut ay ödeme durumu
  getCurrentMonthPaymentStatus: async () => {
    try {
      const response = await api.get('/api/business/payments/current-month-status');
      return response.data;
    } catch (error) {
      console.error('Mevcut ay ödeme durumu getirilirken hata:', error);
      throw error;
    }
  },

  // Ödeme geçmişi
  getMyPayments: async (params = {}) => {
    try {
      const response = await api.get('/api/business/payments/my-payments', { params });
      return response.data;
    } catch (error) {
      console.error('Ödeme geçmişi getirilirken hata:', error);
      throw error;
    }
  },

  // Ödeme istatistikleri
  getPaymentStats: async () => {
    try {
      const response = await api.get('/api/business/payments/stats');
      return response.data;
    } catch (error) {
      console.error('Ödeme istatistikleri getirilirken hata:', error);
      throw error;
    }
  }
};